/*
 * Global select interface.
 */

import { LoadPropType } from '@/components/select/types';

import { Select, SelectList, SelectItem } from './interface';

export default class SelectEntity {
    entity: Select;
    entityName: string;

    constructor(name: string) {
        this.entity = {
            key: name,
            type: 'select',
            title: '',
            list: [],
            current: null,
            required: false,
            disabled: false,
            error: {
                class: '',
                message: '',
            },
            validation: {
                empty: 'Поле не заполнено',
                regex: '',
            },
        };
        this.entityName = name;
    }

    setTitle(title: string) {
        this.entity.title = title;

        return this;
    }

    setList(list: SelectList) {
        this.entity.list = list;

        return this;
    }

    setCurrent(selected: SelectItem) {
        this.entity.current = selected;

        return this;
    }

    setAction(action: string) {
        this.entity.action = action;

        return this;
    }

    setRequired(required: boolean) {
        this.entity.required = required;

        return this;
    }

    setValidation(validation: any) {
        this.entity.validation = validation;

        return this;
    }

    setLoadSettings(settings: LoadPropType) {
        this.entity.loadSettings = settings;

        return this;
    }
}
